export default "__VITE_ASSET__ec5d00e3__"